export const validEmailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/;
export const validEmailRegexForNotify =
  /^([\w.+-]+)@([a-zA-Z\d.-]+\.[a-zA-Z\d]{2,})$/;

export const validPositiveNumber = /^([.]\d+|\d+[.]?\d*|$)$/;
